import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ShieldCheck, ShieldX, Search, Loader2 } from "lucide-react";
import { api, errMsg, useSeo } from "../lib/api";
import { Section } from "../components/Common";

function Result({ r }) {
  if (r.error) return (
    <div className="mt-6 border-l-4 border-[#dc2626] bg-red-50 p-5 flex gap-3" data-testid="verify-invalid">
      <ShieldX className="text-[#dc2626] shrink-0" /><div><p className="font-black">Belge doğrulanamadı</p><p className="text-sm text-zinc-700 mt-1">{r.error}</p></div>
    </div>
  );
  return (
    <div className="mt-6 border-l-4 border-green-600 bg-green-50 p-5" data-testid="verify-valid">
      <p className="font-black flex items-center gap-2 text-green-800"><ShieldCheck />Geçerli belge</p>
      <dl className="mt-4 grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
        {[["Belge No", r.cert_no, "no"], ["Kursiyer", r.name, "name"], ["Ders", r.lesson_title, "lesson"], ["Test başarısı", `%${r.score}`, "score"], ["Veriliş tarihi", r.issued_at, "date"]].map(([k, v, id]) => (
          <div key={k}><dt className="text-xs uppercase tracking-wider text-zinc-500">{k}</dt><dd className="font-bold" data-testid={`verify-${id}`}>{v}</dd></div>
        ))}
      </dl>
      <p className="text-xs text-zinc-500 mt-4">Kişisel verilerin korunması için kursiyer adı kısmen gizlenmiştir.</p>
    </div>
  );
}

export default function CertificateVerify() {
  const [params, setParams] = useSearchParams();
  const [no, setNo] = useState(params.get("no") || "");
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);
  useSeo("Belge Doğrulama", "Ada Özel Güvenlik ders tamamlama belgesinin gerçekliğini belge numarası ile kontrol edin.");
  const check = async (val) => {
    const v = val.trim().toUpperCase();
    if (!v) { setR(null); return; }
    setBusy(true);
    try { setR((await api.get(`/certificates/verify/${encodeURIComponent(v)}`)).data); } catch (x) { setR({ error: errMsg(x) }); } finally { setBusy(false); }
  };
  useEffect(() => { if (params.get("no")) { check(params.get("no")); } }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const submit = (e) => { e.preventDefault(); setParams(no.trim() ? { no: no.trim().toUpperCase() } : {}); check(no); };
  return (
    <Section>
      <div className="max-w-2xl">
        <span className="eyebrow">Ada Özel Güvenlik Eğitim Kurumu</span>
        <h1 className="mt-2 text-3xl sm:text-4xl font-black tracking-tight" data-testid="verify-title">Belge Doğrulama</h1>
        <p className="mt-3 text-zinc-600 text-sm sm:text-base">Ders tamamlama belgesinin üzerindeki belge numarasını girerek belgenin kurumumuz tarafından verildiğini kontrol edebilirsiniz.</p>
        <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-2">
          <div className="relative flex-1"><Search size={18} className="absolute left-3 top-3.5 text-zinc-400" />
            <input className="field !pl-10 uppercase" placeholder="ADA-DB-2026-00001" value={no} onChange={(e) => setNo(e.target.value)} aria-label="Belge numarası" data-testid="verify-input" /></div>
          <button className="btn-red" disabled={busy} data-testid="verify-submit">{busy && <Loader2 size={16} className="animate-spin" />}Doğrula</button>
        </form>
        {r && <Result r={r} />}
      </div>
    </Section>
  );
}
